"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    isDisabled: {
      // 是否仅展示
      type: Boolean,
      default: false
    },
    isEditable: {
      // 是否可编辑售后数量和金额（审核模式）
      type: Boolean,
      default: false
    },
    saleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    orderNo: [Number, String],
    aftersaleNo: [Number, String],
    isCompensationType: {
      // 是否是赔付类型
      type: Boolean,
      default: false
    },
    needQtyAndAmount: {
      // 是否需要填写售后数量和售后金额（仅退款/退货退款时为true）
      type: Boolean,
      default: false
    },
    showLypFields: {
      type: Boolean,
      default: false
    },
    showOneCardActivation: {
      type: Boolean,
      default: false
    },
    /**
     * 订单级立减金额总和，来自订单详情接口 instantDiscountAmount
     * 用于按商品 skuTotalPrice 占比分摊后扣减每件商品最大可退金额
     */
    instantDiscountAmount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      selectIds: [],
      // 选中的商品
      totalAfterSaleAmount: 0 // 假设初始值为0，或者根据实际情况从props、
    };
  },
  watch: {
    'saleList': {
      deep: true,
      immediate: true,
      handler: function handler(newList) {
        var _this = this;
        // 可编辑模式下自动选中所有商品
        if (this.isEditable && newList && newList.length) {
          this.selectIds = _toConsumableArray(newList);
          newList.forEach(function (item) {
            if (item.saleAmount === undefined || item.saleAmount === null) {
              // 使用 getMaxRefundAmount 统一计算（按比例分摊）
              var saleQty = Number(item.saleQty) || Number(item.skuQuantity) || 1;
              _this.$set(item, 'saleQty', saleQty);
              _this.$set(item, 'saleAmount', _this.getMaxRefundAmount(_objectSpread(_objectSpread({}, item), {}, {
                saleQty: saleQty
              })));
            }
          });
        }
        // 只有当有选中项时才更新
        if (this.selectIds && this.selectIds.length) {
          this.updateSelectedItemsAmounts();

          // 通知父组件数据已更新
          this.$nextTick(function () {
            _this.$emit('dataChanged', _this.selectIds);
          });
        }
      }
    }
  },
  computed: {
    showOneCardActivationColumn: function showOneCardActivationColumn() {
      return this.showOneCardActivation && this.saleList.some(function (item) {
        return Number(item.oneCardType) !== 1;
      });
    }
  },
  mounted: function mounted() {},
  methods: {
    formatAfsStatus: function formatAfsStatus(val) {
      var map = {
        1: '申请中',
        2: '售后成功',
        3: '售后失败'
      };
      return map[val] || '--';
    },
    formatPickType: function formatPickType(val) {
      var map = {
        1: '上门取件',
        2: '客户送货',
        3: '客户发货'
      };
      return map[val] || '--';
    },
    formatApplyStatus: function formatApplyStatus(val) {
      var map = {
        1: '待审核',
        2: '已审核',
        3: '已收货',
        4: '已处理',
        5: '已确认',
        6: '已完成',
        7: '已取消'
      };
      return map[val] || '--';
    },
    formatRefundStatus: function formatRefundStatus(val) {
      var map = {
        1: '无退款',
        2: '待退款',
        3: '退款成功'
      };
      return map[val] || '--';
    },
    formatThirdRefundAmount: function formatThirdRefundAmount(val) {
      if (val === null || val === undefined || val === '') return '--';
      var amount = Number(val);
      return Number.isFinite(amount) ? amount.toFixed(2) : val;
    },
    // 按商品 skuTotalPrice 占订单商品总价比例分摊立减金额
    formatInstantDiscount: function formatInstantDiscount(row) {
      var instantDiscount = Number(this.instantDiscountAmount) || 0;
      if (instantDiscount <= 0) return '0';
      var skuTotalPrice = Number(row.skuTotalPrice) || 0;
      var totalSkuPrice = this.totalSkuPrice();
      if (totalSkuPrice <= 0) return '0';
      var share = skuTotalPrice / totalSkuPrice * instantDiscount;
      return share.toFixed(2);
    },
    // 获取最大可退款金额（按比例分摊优惠金额、积分抵扣、立减金额和已退款总额）
    // 实付总额 = 商品总价 - 商品优惠金额 - 积分抵扣金额 - 立减分摊金额
    // 每件实付 = 实付总额 / 购买数量
    // 按比例可退 = 售后数量 × 每件实付
    // 剩余可退 = 实付总额 - 已退款总金额
    // 最大可退 = min(按比例可退, 剩余可退)
    getMaxRefundAmount: function getMaxRefundAmount(row) {
      if (!row || !row.saleQty) return 0;
      var saleQty = Number(row.saleQty) || 0;
      var skuQuantity = Number(row.skuQuantity) || 0;
      var skuTotalPrice = Number(row.skuTotalPrice) || 0;
      var skuCouponPrice = Number(row.skuCouponPrice) || 0;
      var payShopIntegralPrice = Number(row.payShopIntegralPrice) || 0;
      var afterSalePriceTotal = Number(row.afterSalePriceTotal) || 0;
      var instantDiscountAmount = Number(this.instantDiscountAmount) || 0;
      if (skuQuantity <= 0) return 0;

      // 立减金额按 skuTotalPrice 占全部商品总价比例分摊
      var totalSkuPrice = this.totalSkuPrice();
      var instantDiscountShare = 0;
      if (instantDiscountAmount > 0 && totalSkuPrice > 0) {
        instantDiscountShare = skuTotalPrice / totalSkuPrice * instantDiscountAmount;
      }

      // 实付总额 = 商品总价 - 商品优惠金额 - 积分抵扣金额 - 立减分摊金额
      var totalPaid = (0, _ZBKJIutil.Sub)((0, _ZBKJIutil.Sub)((0, _ZBKJIutil.Sub)((0, _ZBKJIutil.Sub)(skuTotalPrice, skuCouponPrice), payShopIntegralPrice), instantDiscountShare), 0);
      // 剩余可退总额 = 实付总额 - 已退款总额
      var remaining = (0, _ZBKJIutil.Sub)(totalPaid, afterSalePriceTotal);
      if (remaining <= 0) return 0;

      // 按比例计算当前售后数量可退金额 = saleQty × 实付总额 / 购买数量
      var proportionalMax = (0, _ZBKJIutil.Div)((0, _ZBKJIutil.Mul)(saleQty, totalPaid), skuQuantity);

      // 取两者较小值，确保不超过剩余可退额度
      var maxRefund = Math.min(proportionalMax, remaining);
      return maxRefund > 0 ? Number(maxRefund.toFixed(2)) : 0;
    },
    // 计算订单商品总价（用于立减分摊）
    totalSkuPrice: function totalSkuPrice() {
      if (!this.saleList || !this.saleList.length) return 0;
      return this.saleList.reduce(function (sum, item) {
        return sum + (Number(item.skuTotalPrice) || 0);
      }, 0);
    },
    // 更新选中商品的金额
    updateSelectedItemsAmounts: function updateSelectedItemsAmounts() {
      var _this2 = this;
      if (this.selectIds && this.selectIds.length) {
        this.selectIds.forEach(function (item) {
          if (item.saleQty && item.skuPrice) {
            var maxAmount = _this2.getMaxRefundAmount(item);

            // 如果当前售后金额大于最大可退金额，则调整
            if (Number(item.saleAmount) > maxAmount) {
              _this2.$set(item, 'saleAmount', maxAmount);
            }
          }
        });
      }
    },
    // 多选框选中数据
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this3 = this;
      this.selectIds = selection;
      this.saleList.forEach(function (item) {
        var isSelected = selection.includes(item);
        if (!isSelected) {
          _this3.$set(item, 'saleQty', 0);
          _this3.$set(item, 'saleAmount', 0);
          _this3.$set(item, 'refundAmount', 0);
        } else {
          // 设置默认数量为购买数量
          var defaultQty = Number(item.skuQuantity) || 1;
          _this3.$set(item, 'saleQty', defaultQty);

          // 计算初始金额（使用 getMaxRefundAmount 按比例统一计算）
          _this3.$set(item, 'saleAmount', _this3.getMaxRefundAmount(_objectSpread(_objectSpread({}, item), {}, {
            saleQty: defaultQty
          })));

          // 初始化退款总金额为 0
          _this3.$set(item, 'refundAmount', 0);
        }
      });

      // 使用 nextTick 确保 DOM 更新后再触发事件
      this.$nextTick(function () {
        _this3.$emit('dataChanged', _this3.selectIds);
      });
    },
    autoFillQuantityAndAmount: function autoFillQuantityAndAmount() {
      var _this4 = this;
      if (!this.selectIds || !this.selectIds.length) return;
      this.selectIds.forEach(function (item) {
        if (!item) return;

        // 设置数量为最大可售后数量
        var maxQty = Number(item.skuQuantity) || 1;
        _this4.$set(item, 'saleQty', maxQty);

        // 计算售后金额（使用 getMaxRefundAmount 按比例统一计算）
        _this4.$set(item, 'saleAmount', _this4.getMaxRefundAmount(_objectSpread(_objectSpread({}, item), {}, {
          saleQty: maxQty
        })));
      });

      // 使用 nextTick 确保 DOM 更新后再触发事件
      this.$nextTick(function () {
        _this4.$emit('dataChanged', _this4.selectIds);
      });
    },
    outPutSelect: function outPutSelect() {
      // 如果是赔付类型，可以不用填写数量和金额，设置为默认值
      if (this.isCompensationType) {
        var outSelect = this.selectIds.length && this.selectIds.map(function (item) {
          var _ref = item || {},
            skuId = _ref.skuId,
            id = _ref.id;
          return {
            quantity: 1,
            // 设置默认数量为 1
            skuId: skuId,
            orderItemId: id,
            saleAmount: 0,
            // 设置默认金额为 0
            refundAmount: 0 // 退款总金额
          };
        });
        this.$emit('selectGoodsIds', outSelect);
        return outSelect || [];
      } else {
        // 原有的逻辑
        var _outSelect = this.selectIds.length && this.selectIds.map(function (item) {
          var _ref2 = item || {},
            skuId = _ref2.skuId,
            saleQty = _ref2.saleQty,
            id = _ref2.id,
            saleAmount = _ref2.saleAmount,
            refundAmount = _ref2.refundAmount;
          return {
            quantity: saleQty,
            skuId: skuId,
            orderItemId: id,
            saleAmount: saleAmount,
            refundAmount: refundAmount || 0 // 退款总金额
          };
        });
        this.$emit('selectGoodsIds', _outSelect);
        return _outSelect || [];
      }
    },
    handerAftersale: function handerAftersale() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var aftersaleNo = arguments.length > 1 ? arguments[1] : undefined;
      // type: 0-创建售后
      if (this.aftersaleNo == aftersaleNo) {
        this.$message.warning('已在当前售后单页面！');
        return;
      }
      ;
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(aftersaleNo ? aftersaleNo : 0, "/").concat(this.orderNo ? this.orderNo : 0, "/").concat(type)
      });
    },
    // 跳转到订单详情
    goToOrderDetail: function goToOrderDetail() {
      this.$emit('goToOrderDetail', this.orderNo);
    },
    handleQtyChange: function handleQtyChange(row, value) {
      var _this5 = this;
      if (!row) return;

      // 确保数量是整数且不超过最大值
      var quantity = Math.min(Math.floor(Number(value)) || 0, Number(row.skuQuantity) || 0);

      // 使用 $set 确保响应性
      this.$set(row, 'saleQty', quantity);

      // 使用 getMaxRefundAmount 按比例统一计算售后金额
      this.$set(row, 'saleAmount', this.getMaxRefundAmount(_objectSpread(_objectSpread({}, row), {}, {
        saleQty: quantity
      })));

      // 通知父组件数据已更新
      this.$nextTick(function () {
        // 使用 nextTick 确保 DOM 更新后再触发事件
        _this5.$emit('dataChanged', _this5.selectIds);
      });
    },
    // 处理售后金额变更
    handleAmountChange: function handleAmountChange(row, value) {
      var _this6 = this;
      if (!row) return;

      // 获取最大可退款金额
      var maxAmount = this.getMaxRefundAmount(row);

      // 确保输入的售后金额不超过最大可退金额
      var amount = Math.min(Number(value) || 0, maxAmount);

      // 使用 $set 确保响应性
      this.$set(row, 'saleAmount', Number(amount.toFixed(2)));

      // 通知父组件数据已更新
      this.$nextTick(function () {
        _this6.$emit('dataChanged', _this6.selectIds);
      });
    }
  }
};